import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Loader2, ShieldCheck } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { api, setAdminToken, getAdminToken } from '../lib/api';
import { useToast } from '../hooks/use-toast';

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const { toast } = useToast();

  useEffect(() => {
    if (getAdminToken()) nav('/admin/dashboard', { replace: true });
  }, [nav]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post('/admin/login', { password });
      setAdminToken(data.token);
      nav('/admin/dashboard', { replace: true });
    } catch (err) {
      toast({ title: 'Login failed', description: err?.response?.data?.detail || 'Invalid password.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#1a0b3d] via-[#2a1456] to-[#5b3eb5] px-5">
      <div className="w-full max-w-md bg-white rounded-3xl p-10 shadow-2xl">
        <div className="flex flex-col items-center text-center mb-7">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#5b3eb5] to-[#e870b6] flex items-center justify-center mb-4 shadow-lg">
            <ShieldCheck className="w-8 h-8 text-white" />
          </div>
          <h1 className="font-serif text-[28px] font-extrabold text-[#1a0b3d]">Admin Login</h1>
          <p className="text-slate-500 text-[14px] mt-1">Ichi &amp; Ori Pet Care Dashboard</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <Label className="flex items-center gap-2 text-[13px] font-semibold text-[#1a0b3d] mb-2">
              <Lock size={14} className="text-[#5b3eb5]" /> Password
            </Label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter admin password"
              required
              className="h-12"
              autoFocus
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full rounded-full bg-[#5b3eb5] hover:bg-[#4a31a3] text-white py-6 h-auto text-[15px] font-semibold gap-2 disabled:opacity-60"
          >
            {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Signing in...</> : <>Sign in</>}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
